import { render } from "./Manual.vue?vue&type=template&id=b4d24958"
import script from "./Manual.vue?vue&type=script&lang=ts"
export * from "./Manual.vue?vue&type=script&lang=ts"
script.render = render

export default script